import { CrudOp, templateAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { TemplateIcon } from "@org-avp/avp-avengers-ui-shared-icons";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { TemplateView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { brand }) => {
  const authHelper = authHelperCreator(templateAuthScope);
  return brand != null && authHelper.evaluate(CrudOp.READ, brand);
};

export const templateViewKey = "template_modular_template/:brand/:template/:projectId/:subprojectId";
export const templateViewModule: ViewModule = {
  viewKey: templateViewKey,
  viewEl: <TemplateView/>,
  displayNameI18nKey: "template:viewName",
  menuIconEl: <TemplateIcon/>,
  isAuthorized,
  translations,
};
